export default __webpack_public_path__ + "static/media/categories.59568bf9.svg";